<template>
  <router-view/>
</template>

<style lang="scss" scoped>
</style>
